import cx from 'classnames';
import { Conditional } from '../../../components/common/conditional';
import { ServiceInsightTabletMobileCard } from './service-insight-tablet-mobile-card';
import { ServiceInsightDesktopCard } from './service-insight-desktop-card';
import { ServiceInsightEmptyState } from './service-insight-empty-state';
import { ServiceInsightCardProps } from '../types';
import styles from '../customer-account.module.scss';

export const ServiceInsightCard = ({
  serviceInsights = [],
  serviceInsightTranslation,
  handleRedirectUrlToAlp,
  isDeskTop
}: ServiceInsightCardProps) => {
  return (
    <Conditional
      test={serviceInsights.length > 0}
      fallback={
        <ServiceInsightEmptyState
          serviceInsightTranslation={serviceInsightTranslation}
        />
      }
    >
      <div
        className={cx('d-flex flex-column gap-2 gap-blg-0 pb-4 pb-blg-0', {
          [styles['serviceInsightCard']]: isDeskTop
        })}
      >
        {!isDeskTop
          ? serviceInsights
              .slice(0, 2)
              .map((item) => (
                <ServiceInsightTabletMobileCard
                  key={item.id}
                  serviceInsights={item}
                  handleRedirectUrlToAlp={handleRedirectUrlToAlp}
                />
              ))
          : serviceInsights.map((item) => (
              <ServiceInsightDesktopCard
                key={item.id}
                serviceInsights={item}
                serviceInsightTranslation={serviceInsightTranslation}
                handleRedirectUrlToAlp={handleRedirectUrlToAlp}
              />
            ))}
      </div>
    </Conditional>
  );
};
